
import { Component, Prop, Ref, Vue } from 'nuxt-property-decorator'
import StylizedModal from './common/StylizedModal.vue'
import { WebPlayerThemeUtil } from './utils/WebPlayerThemeUtil'
import { PlatformSettingsWeb } from '~/api'

@Component
export default class WebPlayerInteractionModal extends Vue {
  @Ref('interaction-modal') public modal!: StylizedModal
  @Prop() platformSettings!: PlatformSettingsWeb

  show() {
    this.modal.show()
  }

  close() {
    this.modal.hide()
  }

  get buttonStyle() {
    return WebPlayerThemeUtil.buttonStyle(this.platformSettings)
  }
}
